// Set-Namen-Map (Kürzel → { name, cardmarketName }) für die Export-Modals.
// Ändert sich nur beim Admin-Bulk-Import → lange staleTime, Fetch nur bei geöffnetem Modal.
import { useQuery } from '@tanstack/react-query';
import { json } from '../api/apiClient';

export default function useCardSets(enabled = true) {
  return useQuery({
    queryKey: ['cardSets'],
    queryFn: () => json('/api/sets'),
    staleTime: 1000 * 60 * 60, // 1 Stunde
    enabled,
  });
}
